<div ngModelGroup="comboPublicoAlvo-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="{{fxFlexOffset}}">
    <combo-pesquisavel #comboIdDescricao
                       nome="publicoAlvo-{{data}}" 
                       [itens]="dados" 
                       [itemDescricao]="campoPesquisavel"
                       itemId="id"
                       [showDisplayId]="showDisplayId" 
                       label="{{label}}"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Escolha..."
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>


